/*
Контент-гейт прибавляет (1) в конце к названию файла, если загрузить картинку несколько раз.
Способ вставки бэкграунда backgroundImage: `url(${url})` работает некорректно в данном случае,
т.е. картинки не отображаются на странице запроса, поэтому необходимо использовать данную функцию
*/
export const formatImageUrl = (url: string) => `url("${url}")`;
